// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import React from 'react';

// import AuthProvider, { AuthCtx } from './context/AuthContext';
// import PrivateRoute from './components/PrivateRoute';

// import Login from './pages/LoginPage';
// import CommunityList from './pages/CommunityList';
// import CommunityForm from './pages/CommunityForm';
// import CommunityEdit from './pages/CommunityEdit';

// /* ───────── helper that decides where “/” should go ───────── */
// function RootRedirect() {
//   const { user } = React.useContext(AuthCtx);
//   return <Navigate to={user ? '/communities' : '/login'} replace />;
// }

// export default function App() {
//   return (
//     <BrowserRouter>
//       <AuthProvider>
//         <Routes>
//           {/* default root */}
//           <Route path="/" element={<RootRedirect />} />

//           {/* public */}
//           <Route path="/login" element={<Login />} />

//           {/* protected list */}
//           <Route
//             path="/communities"
//             element={
//               <PrivateRoute>
//                 <CommunityList />
//               </PrivateRoute>
//             }
//           />

//           {/* protected new-community form */}
//           <Route
//             path="/community/new"
//             element={
//               <PrivateRoute>
//                 <CommunityForm />
//               </PrivateRoute>
//             }
//           />
//           <Route
//           path="/community/:id/edit"
//         element={
//             <PrivateRoute>
//             <CommunityEdit />
//             </PrivateRoute>
//             }
//           />
//           {/* catch-all → go to “/” so RootRedirect handles it */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </AuthProvider>
//     </BrowserRouter>
//   );
// }




// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import React from 'react';

// import AuthProvider, { AuthCtx } from './context/AuthContext';
// import PrivateRoute from './components/PrivateRoute';

// import Login from './pages/LoginPage';
// import CommunityList from './pages/CommunityList';
// import CommunityForm from './pages/CommunityForm';
// import CommunityEdit from './pages/CommunityEdit';

// // ✅ Events pages (make sure these files exist)
// import EventsList from './pages/EventsList';
// import EventForm from './pages/EventForm';
// import EventEdit from './pages/EventEdit';

// // ✅ Home page
// import Home from './pages/Home';

// /* ───────── helper that decides where “/” should go ───────── */
// function RootRedirect() {
//   const { user } = React.useContext(AuthCtx);
//   return <Navigate to={user ? '/home' : '/login'} replace />;
// }

// export default function App() {
//   return (
//     <BrowserRouter>
//       <AuthProvider>
//         <Routes>
//           {/* default root */}
//           <Route path="/" element={<RootRedirect />} />

//           {/* public */}
//           <Route path="/login" element={<Login />} />

//           {/* protected: Home */}
//           <Route
//             path="/home"
//             element={
//               <PrivateRoute>
//                 <Home />
//               </PrivateRoute>
//             }
//           />

//           {/* protected: communities */}
//           <Route
//             path="/communities"
//             element={
//               <PrivateRoute>
//                 <CommunityList />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/community/new"
//             element={
//               <PrivateRoute>
//                 <CommunityForm />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/community/:id/edit"
//             element={
//               <PrivateRoute>
//                 <CommunityEdit />
//               </PrivateRoute>
//             }
//           />

//           {/* protected: events */}
//           <Route
//             path="/events"
//             element={
//               <PrivateRoute>
//                 <EventsList />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/events/new"
//             element={
//               <PrivateRoute>
//                 <EventForm />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/events/:id/edit"
//             element={
//               <PrivateRoute>
//                 <EventEdit />
//               </PrivateRoute>
//             }
//           />

//           {/* catch-all → go to “/” so RootRedirect handles it */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </AuthProvider>
//     </BrowserRouter>
//   );
// }




import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';

import AuthProvider, { AuthCtx } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

import Login from './pages/LoginPage';
import Home from './pages/Home';                // ✅ new
import CommunityList from './pages/CommunityList';
import CommunityForm from './pages/CommunityForm';
import CommunityEdit from './pages/CommunityEdit';
import EventsList from './pages/EventsList';
import EventForm from './pages/EventForm';
import EventEdit from './pages/EventEdit';

import AppLayout from './layouts/AppLayout';    // ✅ new

function RootRedirect() {
  const { user } = React.useContext(AuthCtx);
  return <Navigate to={user ? '/home' : '/login'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* public */}
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />

          {/* protected layout wraps all app pages */}
          <Route
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          >
            <Route path="/home" element={<Home />} />
            <Route path="/communities" element={<CommunityList />} />
            <Route path="/community/new" element={<CommunityForm />} />
            <Route path="/community/:id/edit" element={<CommunityEdit />} />

            <Route path="/events" element={<EventsList />} />
            <Route path="/events/new" element={<EventForm />} />
            <Route path="/events/:id/edit" element={<EventEdit />} />
          </Route>

          {/* catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
